<template>
  <div class="container content-430">
    <div class="header-wrapper-430">
      <SearchAgreement @on-search="handleSearch"></SearchAgreement>
      <div
        class="action-main flex justify-content_end"
        style="margin-bottom: 8px"
      >
        <Button
          v-if="portOrg == 0"
          type="primary"
          @click="handleBatch"
        >批量设置</Button>
        <Button
          v-if="portOrg == 0"
          type="primary"
          style="margin-left: 16px"
          @click="handleAdd"
        >创建服务协议</Button>
        <Button
          type="primary"
          style="margin-left: 16px"
          @click="handleDownload"
        >下载</Button>
      </div>
    </div>
    <div class="table-main">
      <Table
        :columns="tableColumns"
        :data="tableData"
        border=""
        :loading="tableLoading"
        :max-height="tableHeight"
        @on-selection-change="tableColumnsChange"
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>

        <template slot="orgFileId" slot-scope="{ row }">
          <span v-if="row.orgFileId" class="color-blue">已上传</span>
          <span v-else class="color-orange">待上传</span>
        </template>
        <template slot="platFileId" slot-scope="{ row }">
          <span v-if="row.platFileId" class="color-blue">已上传</span>
          <span v-else class="color-orange">待上传</span>
        </template>
        <template slot="schoolFileId" slot-scope="{ row }">
          <span v-if="row.schoolFileId" class="color-blue">已上传</span>
          <span v-else class="color-orange">待上传</span>
        </template>

        <template slot="isSign" slot-scope="{ row }">
          <span v-if="row.isSign == 1" class="color-blue">是</span>
          <span v-else class="color-orange">否</span>
        </template>
        <template slot="templateSts" slot-scope="{ row }">
          <span v-if="row.templateSts == 1" class="color-blue">已启用</span>
          <span v-else class="color-orange">已停用</span>
        </template>
        <template slot="configSts" slot-scope="{ row }">
          <span v-if="row.configSts == 1" class="color-blue">已完成</span>
          <span v-else class="color-orange">待配置</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div v-if="portOrg != 1">
            <span
              class="click-btn-430"
              @click="handleManage(row)"
            >协议上传管理</span>
            <span
              v-if="portOrg == 0"
              class="click-btn-430"
              @click="handleEdit(row)"
            >修改</span>
            <span
              v-if="portOrg == 0"
              class="click-btn-430"
              @click="handleDelete(row)"
            >
              删除</span>
          </div>
          <div v-else><span class="click-btn-430">--</span></div>
        </template>
      </Table>
    </div>

    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-sizer
        show-total
        show-elevator
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="onPageSizeChange"
      ></Page>
    </div>
    <BatchSetting
      ref="batchSettingRef"
      :active-selection="activeSelection"
      @on-finish="onBatchFinish"
    ></BatchSetting>
  </div>
</template>

<script>
import SearchAgreement from './components/SearchAgreement.vue';
import BatchSetting from './components/BatchSetting.vue';
import platformApi from '@/request/eduCenter/platform.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { getTableColumns } from './components/data/index';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import { mapMutations } from 'vuex';
export default {
  name: 'PlatformAgreementManage',
  components: {
    SearchAgreement,
    BatchSetting
  },
  mixins: [mixinTableHeight],
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('PlatformAgreementManage');
    next();
  },
  data() {
    return {
      portOrg: Number(localStorage.getItem('portOrg')),
      tableLoading: false,
      tableColumns: getTableColumns(localStorage.getItem('portOrg')),
      tableData: [],
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchInfo: {},
      activeSelection: []
    };
  },
  activated() {
    this.getServiceAgreementTemplatePage();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    handleSearch(info) {
      this.searchInfo = info;
      this.pageInfo.pageNum = 1;
      this.getServiceAgreementTemplatePage();
    },

    getParameter() {
      const { pageNum, pageSize } = this.pageInfo;
      return {
        pageNum,
        pageSize,
        ...this.searchInfo
      };
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getServiceAgreementTemplatePage();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getServiceAgreementTemplatePage();
    },

    async getServiceAgreementTemplatePage() {
      const parameter = this.getParameter();
      this.tableLoading = true;
      const res = await platformApi.getServiceAgreementTemplatePage(parameter);
      this.tableLoading = false;
      if (res.status == 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否确定删除？</p>',
        onOk: async() => {
          const res = await platformApi.deleteServiceAgreementTemplate({
            agreementId: row.agreementId
          });
          if (res.status == 200) {
            this.$Message.success('删除成功');
            this.pageInfo.pageNum = 1;
            this.getServiceAgreementTemplatePage();
          }
        },
        onCancel: () => {

        }
      });
    },
    handleBatch() {
      if (this.activeSelection.length < 1) {
        this.$Message.warning('请至少选择一个一条协议！');
        return null;
      }
      this.$refs.batchSettingRef.handleShow();
    },
    handleEdit(row) {
      this.$router.push({
        name: 'eduCenter_platform_agreementManageAdd',
        query: { agreementId: row.agreementId }
      });
    },
    handleAdd() {
      this.$router.push({
        name: 'eduCenter_platform_agreementManageAdd'

      });
    },
    handleManage(row) {
      this.$router.push({
        name: 'eduCenter_platform_agreementPdf',
        query: { agreementId: row.agreementId }
      });
    },

    // 选中的商品ID
    tableColumnsChange(selection) {
      this.activeSelection = selection;
    },
    async serviceAgreementTemplateExport() {
      const parameter = this.getParameter();
      parameter.pageSize = this.pageInfo.total;
      this.$Spin.show();
      const res = await platformApi.serviceAgreementTemplateExport(parameter);
      this.$Spin.hide();
      downLoadByBlob(res);
    },
    onBatchFinish() {
      this.getServiceAgreementTemplatePage();
    },
    handleDownload() {
      this.serviceAgreementTemplateExport();
    }
  }
};
</script>

<style>
</style>
